import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import { Instagram, Twitter } from "lucide-react";
import Header from "./Header";
import toast from "react-hot-toast";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const handled = useRef(false);
  useEffect(() => {
    if (handled.current) return;
    const hash = typeof window !== "undefined" ? window.location.hash || "" : "";
    if (hash && hash.includes("error=")) {
      const params = new URLSearchParams(hash.startsWith("#") ? hash.substring(1) : hash);
      const code = params.get("error_code") || params.get("error") || "error";
      const desc = params.get("error_description") || "Authentication error";
      const msg = code === "otp_expired" ? "Email link is invalid or has expired" : desc;
      toast.error(msg);
      if (typeof window !== "undefined") {
        const url = window.location.pathname + window.location.search;
        window.history.replaceState(null, "", url);
      }
      handled.current = true;
    }
  }, []);
  return (
    <div className="Layout  bg-white px-[8px] py-1   md:px-[13px] md:py-2  lg:px-[25px] lg:py-4  xl:py-[50px] xl:px-[120px]">
      {/* Header */}
      <Header />
      {/* Main Content */}
      <main className="min-h-[calc(100vh-479px)]">{children}</main>

      {/* Footer */}
      <footer>
        <div
          className="w-full justify-between flex md:flex-row flex-col md:py-[30px] py-2 gap-2"
          style={{
            background: "rgba(0, 0, 0, 0)",
            borderTop: "1px #E5E7EB solid",
            alignItems: "center",

            fontSize: "14px",
            fontFamily: "Abhaya Libre",
            fontWeight: "400",
            lineHeight: "16px",
            letterSpacing: 0.6,
            wordWrap: "break-word",
          }}
        >
          <div
            className="w-max"
            style={{
              color: "#737373",
            }}
          >
            © 2025 The Beat. All Rights Reserved.
          </div>
          {/* <div style={{ width: 73.25, height: 15, position: "relative", background: "rgba(0, 0, 0, 0)" }}>
            <Instagram
              className="w-5 h-5"
              style={{
                color: "#737373",
                left: 0,
                top: 0,
                position: "absolute",
                overflow: "hidden",
                justifyContent: "center",
                alignItems: "center",
                display: "inline-flex",
              }}
            />
            <Twitter
              className="w-5 h-5"
              style={{
                color: "#737373",
                left: 31,
                top: 0,
                position: "absolute",
                overflow: "hidden",
                justifyContent: "center",
                alignItems: "center",
                display: "inline-flex",
              }}
            />
          </div> */}
          <div
            className="w-max"
            style={{
              textAlign: "right",
              color: "#737373",
            }}
          >
            <Link to="/privacy-policy" style={{ color: "#737373", textDecoration: "none" }}>
              Privacy Policy
            </Link>
            <span style={{ marginLeft: "6px", marginRight: "6px" }}>|</span>
            <Link to="/terms-of-service" style={{ color: "#737373", textDecoration: "none" }}>
              Terms of Service
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
